import Vue from 'vue';
import App from './App.vue'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import 'babel-polyfill'
import './registerServiceWorker'

import '@/api/feathers-client'

import iView from 'iview';
import 'iview/dist/styles/iview.css';
import './less/lc-iview.less'
import locale from 'iview/dist/locale/en-US';


import moment from 'vue-moment'
import VueCookies from 'vue-cookies'


import Toastr from 'vue-toastr';
require('vue-toastr/src/vue-toastr.scss');

import VueClipboard from 'vue-clipboard2'





Vue.config.productionTip = false
Vue.use(VueI18n);
Vue.use(iView, { locale });
Vue.use(Toastr);
Vue.use(moment);
Vue.use(VueCookies);
Vue.use(VueClipboard);


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
